import React, { useState, useEffect, useRef } from 'react';
import profile from "../../assets/profile.jpg";
import { Link, useNavigate } from 'react-router-dom';
import Menu from './Menu';
import { CiMenuFries } from 'react-icons/ci';
import { useAuth } from '../../context/AuthProvider';
import { Logout } from '../../api/api';
import toast from 'react-hot-toast';

const Navbar = () => {
  const [isNotificationsMenuOpen, setIsNotificationsMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(true); // Default to true for desktop
  const navigate = useNavigate();
  const { setUser,setLogin,user } = useAuth();

  const notificationRef = useRef(null);
  const profileRef = useRef(null);

  const toggleNotificationsMenu = () => {
    setIsNotificationsMenuOpen(!isNotificationsMenuOpen);
  };

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const closeMenus = (e) => {
    if (notificationRef.current && !notificationRef.current.contains(e.target)) {
      setIsNotificationsMenuOpen(false);
    }
    // Close profile menu if clicked outside
    if (profileRef.current && !profileRef.current.contains(e.target)) {
      setIsProfileMenuOpen(false);
    }
  };

  useEffect(() => {
    // Add event listener for clicks outside of dropdowns
    document.addEventListener('mousedown', closeMenus);

    return () => {
      // Clean up event listener
      document.removeEventListener('mousedown', closeMenus);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle menu visibility
  };

  // Adjust the menu state based on the window size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMenuOpen(true);
      } else {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();  

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className=" py-4 w-full fixed bg-white shadow-md dark1:bg-gray-800 z-40">
      <div className="container flex justify-between h-full px-6 mx-auto text-black dark1:text-purple-300">
        {/* Mobile hamburger */}
        <div className="flex items-center">
          <button onClick={toggleMenu} className="md:hidden">
            <CiMenuFries className="w-8 h-8" />
          </button>
        </div>

        <ul className="flex items-center justify-end  space-x-6">
   
          {/* <li className="relative" ref={notificationRef}>
            <button
              className="relative align-middle rounded-md focus:outline-none focus:shadow-outline-purple"
              onClick={toggleNotificationsMenu}
              aria-label="Notifications"
              aria-haspopup="true"
            >
              <svg className="w-5 h-5 text-black" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
              </svg>
              <span className="absolute top-0 right-0 w-3 h-3 bg-red-600 border-2 border-white rounded-full dark1:border-gray-800" />
            </button>
            {isNotificationsMenuOpen && (
              <ul className="absolute right-0 w-56 p-2 mt-2 space-y-2 text-gray-600 bg-white border rounded-md shadow-md dark1:bg-gray-700 dark1:text-gray-300 dark1:border-gray-700">
                <li className="flex">
                  <a className="inline-flex items-center justify-between w-full px-2 py-1 text-sm font-semibold hover:bg-gray-100 dark1:hover:bg-gray-800">
                    <span>Messages</span>
                    <span className="px-2 py-1 text-xs font-bold text-red-600 bg-red-100 rounded-full dark1:bg-red-600 dark1:text-red-100">13</span>
                  </a>
                </li>
                <li className="flex">
                  <a className="inline-flex items-center justify-between w-full px-2 py-1 text-sm font-semibold hover:bg-gray-100 dark1:hover:bg-gray-800">
                    <span>Sales</span>
                    <span className="px-2 py-1 text-xs font-bold text-red-600 bg-red-100 rounded-full dark1:bg-red-600 dark1:text-red-100">2</span>
                  </a>
                </li>
              </ul>
            )}
          </li> */}

          {/* Profile menu */}
          <li className="relative" ref={profileRef}>
            <button
              className="align-middle rounded-full focus:shadow-outline-purple focus:outline-none flex flex-row-reverse gap-2 justify-center items-center"
              onClick={toggleProfileMenu}
              aria-label="Account"
              aria-haspopup="true"
            >
              <img className="object-cover w-8 h-8 rounded-full" src={profile} alt="" aria-hidden="true" />
              <span>{user?.email || 'unknown'}</span>
            </button>
            {isProfileMenuOpen && (
              <ul className="absolute right-0 w-48 p-2 mt-2 space-y-2 text-gray-600 bg-white border rounded-md shadow-md dark1:bg-gray-700 dark1:text-gray-300 dark1:border-gray-700">
                {/* <li className="flex">
                  <Link className="inline-flex items-center justify-between w-full px-2 py-1 text-sm font-semibold hover:bg-gray-100 dark1:hover:bg-gray-800" to="/profile">
                    <span>Profile</span>
                  </Link>
                </li> */}
                <li className="flex">
                  <button
                    className="inline-flex items-center justify-between w-full px-2 py-1 text-sm font-semibold hover:bg-gray-100 dark1:hover:bg-gray-800"
                    onClick={() => {
                     
                      Logout().then((res)=>{
                        toast.success(res.message)
                        setLogin(false)
                      setUser(null);
                      navigate('/');

                      })
                      
                    }}
                  >
                    Log out
                  </button>
                </li>
              </ul>
            )}
          </li>
        </ul>
      </div>
      <Menu isOpen={isMenuOpen} toggleMenu={toggleMenu} /> {/* Pass props to Menu */}
    </header>
  );
};

export default Navbar;
